<mp-search-bar
  [searchTerm]="searchTerm"
  [field]="field"
  [fieldOptions]="fieldOptions"
  searchFieldPlaceholder="Plattformkataloge durchsuchen"
  (manualSearched)="onManualSearch($event)"
/>
